module.exports = __webpack_public_path__ + "static/media/filled_bar_M3_tall.c968ecb7.svg";